import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./profile.css";

const Profile = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsed = JSON.parse(storedUser);

      setUserData({
        ...parsed,
        joinedAt: parsed.joinedAt || parsed.created_at,
      });
    }
  }, []);

  if (!userData) {
    return (
      <div className="profile-container">
        <p className="loading-text">Loading your profile...</p>
      </div>
    );
  }

  return (
    <div className="profile-container">
      <div className="profile-card">

        {/* 🔥 HEADER */}
        <div className="profile-header">
         {/*  <img
            src={userData.avatar || "https://via.placeholder.com/100"}
            alt="avatar"
            className="profile-avatar"
          />*/}
          <h2>{userData.username || "User"}</h2>
          <p className="email">{userData.email}</p>

          <Link to="/settings">
            <button className="edit-btn">
              <i className="fa-solid fa-gear"></i> Edit Profile
            </button>
          </Link>
        </div>

        {/* 🔥 INFO */}
        <div className="profile-info">

          <div className="info-item">
            <i className="fa-solid fa-id-badge"></i>
            <span><strong>Username:</strong> {userData.username}</span>
          </div>

          <div className="info-item">
            <i className="fa-solid fa-envelope"></i>
            <span><strong>Email:</strong> {userData.email}</span>
          </div>

          <div className="info-item">
            <i className="fa-solid fa-calendar"></i>
            <span>
              <strong>Joined:</strong>{" "}
              {userData.joinedAt
                ? new Date(userData.joinedAt).toLocaleDateString()
                : "N/A"}
            </span>
          </div>

          <div className="info-item">
            <i className="fa-solid fa-clock"></i>
            <span>
              <strong>Last Login:</strong>{" "}
              {userData.last_login
                ? new Date(userData.last_login).toLocaleString()
                : "N/A"}
            </span>
          </div>

        </div>

        {/* 🔥 STATS */}
        <div className="profile-stats">
          <div className="stat-box">
            <i className="fa-solid fa-upload"></i>
            <h3>{userData.uploads || 0}</h3>
            <p>Uploads</p>
          </div>

          <div className="stat-box">
            <i className="fa-solid fa-eye"></i>
            <h3>{userData.views || 0}</h3>
            <p>Views</p>
          </div>

          <div className="stat-box">
            <i className="fa-solid fa-coins"></i>
            <h3>{userData.coins || 0}</h3>
            <p>Coins</p>
          </div>
        </div>

        {/* 🔥 SERVER INFO (Perfect for your Minecraft setup) */}
        <div className="profile-server">
          <h3>Server Info</h3>

          <div className="info-item">
            <span><strong>Rank:</strong> {userData.rank || "Member"}</span>
          </div>

          <div className="info-item">
            <span><strong>Playtime:</strong> {userData.playtime || "0h"}</span>
          </div>
        </div>

        {/* 🔥 SOCIAL LINKS */}
        <div className="profile-social">
          <h3>Connections</h3>

          <p><strong>Discord:</strong> {userData.discord || "Not linked"}</p>
          <p><strong>YouTube:</strong> {userData.youtube || "Not linked"}</p>
          <p><strong>Website:</strong> {userData.website || "Not set"}</p>
        </div>

        {/* 🔥 LOGOUT */}
        <button
          className="logout-btn"
          onClick={() => {
            localStorage.removeItem("user");
            window.location.href = "/login";
          }}
        >
          <i className="fa-solid fa-right-from-bracket"></i> Logout
        </button>

      </div>
    </div>
  );
};

export default Profile;